export enum AddressStatus {
    PotentialCustomer = 'potentieller Kunde', // pick list item in address Kundenstatus
    Customer = 'Kunde',
}